import React, { Component } from 'react'
import { vuHQLink } from '../../../helpers/links'
import Loading from '../Loading'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { getYearsEnrolled } from '../../../helpers/enrolment'
import { fetchUnitsIfNeeded } from '../../../actions/units'
import Select from '@mui/material/Select';
import { FormControl, MenuItem } from '@mui/material'

const mapStateToProps = ({ courses: { selectedCourseCode, data }, course: { selectedCourse }, units, currentUser }) => {
  return {
    course: selectedCourse,
    courseCode: selectedCourseCode,
    parentSSPNo: selectedCourse.parentSSPNo,
    loadingUnits: units[selectedCourseCode].receivedAt === null || units[selectedCourseCode].isFetching,
    units: units[selectedCourseCode].items,
    userRole: currentUser.data['role'],
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchUnits: (courseCode, parentSSPNo) => {
      dispatch(fetchUnitsIfNeeded(courseCode, parentSSPNo))
    }
  }
}

class ConfirmationOfEnrolmentReport extends Component {
  constructor(props) {
    super(props)

    this.state = {
      enrolledYears : []
    }
  }

  componentDidMount() {
    if (this.props.userRole == 'STUDENT') {
      this.props.fetchUnits(this.props.courseCode, this.props.parentSSPNo)
    }
    this.setState({ 
      enrolledYears : this.props.units ? this.populateListOptions(getYearsEnrolled(this.props.units, true)) : [],
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.userRole == 'STUDENT') {
      if (prevProps.courseCode !== this.props.courseCode) {
        this.props.fetchUnits(this.props.courseCode, this.props.parentSSPNo)
      }
    }
    if (prevProps.loadingUnits && !this.props.loadingUnits) {
      const enrolledYears = this.populateListOptions(getYearsEnrolled(this.props.units, true))
      this.setState({ enrolledYears })
    }
  }

  populateListOptions(listOptions) {
    let options = []
    listOptions.map(item => options.push({ label: item, value: item }))
    return options
  }

  handleFormSubmit = event => {
    this.props.submit(event)
  }

  handleFormCancel = event => {
    this.props.cancel(event)
  }

  render() {
    const { enrolledYears } = this.state;

    if (this.props.loadingUnits) {
      return (
        <section>
          <Loading message="Loading your available years..." />
        </section>
      )
    }

    return (
      <div className='reports-page-container'>
        <div className={'reports-page-heading'}>
          <h2>Request an enrolment confirmation</h2>

          <div>An enrolment confirmation provides evidence of your enrolment in a course at Victoria University for a nominated year.</div>
          <div>
            You can request an enrolment confirmation for the current year on this page. If you require an enrolment confirmation for a different year, please {vuHQLink('contact VUHQ')} for
            assistance.
          </div>
        </div>

        <div className={'reports-sub-heading'}>
          <h3>Request</h3>

          <div>To request an enrolment confirmation, click 'Submit my request' below.</div>
          <div>The enrolment confirmation will be sent via email to your VU student email account within 24 hours.</div>
        </div>

        <div className={'coe-request-details'}>
          <div className="row">
            <div className={'col-xs-12 col-md-2 col-lg-1 column-1'}>Course</div>
            <div className={'col-lg'}>{this.props.courseTitle}</div>
          </div>
          <div className="row">
            <div className={'col-xs-12 col-md-2 col-lg-1 column-1'}>Year</div>
            <div className={'col-lg'}>
              <Select
                id='enrolledYearsID'
                name="enrolledYears"
                value={this.props.year}
                options={enrolledYears || []}
                onChange={this.props.handleOnChangeOfYears}
                variant="standard"
                sx={{marginTop: '0 !important', width: 100}}
              >
                { !enrolledYears.length ? null : enrolledYears.map(enrolledYear => {
                  return (
                    <MenuItem key={enrolledYear.value} value={enrolledYear.value}>{enrolledYear.label}</MenuItem>
                  )
                })}
              </Select>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-md-3">
            <button disabled={this.props.submitting} className="btn btn-lg btn-primary" onClick={event => this.handleFormSubmit(event)}>
              Submit my request
            </button>
          </div>
          <div className="col-xs-12 col-md-3">
            <button disabled={this.props.submitting} className="btn btn-lg btn-secondary" onClick={event => this.handleFormCancel(event)}>
              Cancel
            </button>
          </div>
        </div>
      </div>
    )
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ConfirmationOfEnrolmentReport)
)
